// my lodash base functions
export function isArray(data: any) {
  return Object.prototype.toString.call(data) === "[object Array]";
}
